import SJ from "scriptjs";
var cl = null;

function o() {
  var d = window.document,
    a = d.documentElement;
  var c =
      a.getBoundingClientRect().width > 750
        ? 750
        : a.getBoundingClientRect().width,
    b = c / (750 / 100);
  a.style.fontSize = b + "px";
}

window.addEventListener(
  "resize",
  () => {
    clearTimeout(cl);
    cl = setTimeout(() => {
      o();
    }, 300);
  },
  !1
);
o();

// function handleFontSize() {
//   // 设置网页字体为默认大小
//   WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
//   // 重写设置网页字体大小的事件
//   WeixinJSBridge.on("menu:setfont", function() {
//     WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
//   });
// }
// if (
//   typeof WeixinJSBridge == "object" &&
//   typeof WeixinJSBridge.invoke == "function"
// ) {
//   handleFontSize();
// } else {
//   if (document.addEventListener) {
//     document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
//   } else if (document.attachEvent) {
//     document.attachEvent("WeixinJSBridgeReady", handleFontSize);
//     document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
//   }
// }

import Vue from "vue";
import axios from "axios";
import WebStorageCache from "web-storage-cache";

import alertBox from "../../components/alert.vue";
import hintBox from "../../components/hint.vue";
import bindBox from "../../components/bind.vue";

import device from "./device";
import conf from "./conf";

// 弹窗
const AlertBoxs = Vue.extend(alertBox);
const HintBoxs = Vue.extend(hintBox);
const BindBoxs = Vue.extend(bindBox);

let AlertBox = {};
let instance = new AlertBoxs({
  el: document.createElement("div"),
});

let hintinstance = new HintBoxs({
  el: document.createElement("div"),
});

let bindinstance = new BindBoxs({
  el: document.createElement("div"),
});

AlertBox.alert = (message, title, options) => {
  if (typeof title === "object") {
    options = title;
    title = "";
  }
  options = common.merge(
    {
      title: title ? title : "",
      message: message,
      confirmButtonText: "知道啦",
    },
    options
  );
  const defaultCallback = (msgbox) => {
    msgbox.show = false;
  };
  if (!instance.show) {
    for (let prop in options) {
      if (options.hasOwnProperty(prop)) {
        instance[prop] = options[prop];
      }
    }
    if (options.callback === undefined) {
      instance.callback = defaultCallback;
    }
    const oldCb = instance.callback;
    instance.callback = (msgbox) => {
      msgbox.show = false;
      oldCb(msgbox);
    };
    document.body.appendChild(instance.$el);

    Vue.nextTick(() => {
      instance.show = true;
    });
  }
};

AlertBox.hint = (message, type, img, time, callback) => {
  if (typeof time === "function") {
    callback = time;
    time = 2000;
  }
  const options = {
    message: message,
    type: type,
    img: img,
    time: time ? time : 2000,
    callback: callback,
  };

  if (!hintinstance.show) {
    for (let prop in options) {
      if (options.hasOwnProperty(prop)) {
        hintinstance[prop] = options[prop];
      }
    }
    document.body.appendChild(hintinstance.$el);

    Vue.nextTick(() => {
      hintinstance.show = true;
    });
  }
};

AlertBox.bind = (callback, isclose) => {
  const options = {
    isclose: isclose,
    callback: callback,
  };

  if (!bindinstance.show) {
    for (let prop in options) {
      if (options.hasOwnProperty(prop)) {
        bindinstance[prop] = options[prop];
      }
    }
    document.body.appendChild(bindinstance.$el);

    Vue.nextTick(() => {
      bindinstance.show = true;
    });
  }
};

var common = {
  MsgBox: AlertBox,
  wsCache: new WebStorageCache(),
  // 验证手机
  checkPhone(tel) {
    var phone = /^1[0-9]{10}$/;
    if (phone.test(tel)) {
      return true;
    } else {
      return false;
    }
  },
  // 验证身份证（18位&15位）
  checkIdCard(IDCard) {
    const isIDCard18 = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|x|X)$/;
    const isIDCard15 = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
    if (isIDCard15.test(IDCard) || isIDCard18.test(IDCard)) {
      return true;
    } else {
      return false;
    }
  },
  // 验证身份证（强）
  checkIdCardSerious(IDCard) {
    // 位数验证
    const isIDCard18 = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|x|X)$/;
    const isIDCard15 = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
    if (isIDCard15.test(IDCard) || isIDCard18.test(IDCard)) {
      IDCard = common.changeFivteenToEighteen(IDCard);
      if (common.checkCode(IDCard)) {
        const date = IDCard.substring(6, 14);
        if (common.checkDate(date)) {
          if (common.checkProv(IDCard.substring(0, 2))) {
            return true;
          }
        }
      }
      return false;
    } else {
      return false;
    }
  },
  // 验证身份证（强）验证身份证前2位
  checkProv(val) {
    const pattern = /^[1-9][0-9]/;
    const provs = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江 ",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北 ",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏 ",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
    };
    if (pattern.test(val)) {
      if (provs[val]) {
        return true;
      }
    }
    return false;
  },
  // 验证身份证（强）验证身份证生日
  checkDate(val) {
    const pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
    if (pattern.test(val)) {
      const year = val.substring(0, 4);
      const month = val.substring(4, 6);
      const date = val.substring(6, 8);
      const date2 = new Date(year + "-" + month + "-" + date);
      if (date2 && date2.getMonth() == parseInt(month) - 1) {
        return true;
      }
    }
    return false;
  },
  // 验证身份证（强）验证校验码
  checkCode(val) {
    const p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
    const code = val.substring(17);
    if (p.test(val)) {
      let sum = 0;
      for (let i = 0; i < 17; i++) {
        sum += val[i] * factor[i];
      }
      if (parity[sum % 11] == code.toUpperCase()) {
        return true;
      }
    }
    return false;
  },
  // 升级15位身份证号码到18位
  changeFivteenToEighteen(card) {
    if (card.length == "15") {
      const arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      const arrCh = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
      let cardTemp = 0,
        i;
      card = card.substr(0, 6) + "19" + card.substr(6, card.length - 6);
      for (i = 0; i < 17; i++) {
        cardTemp += card.substr(i, 1) * arrInt[i];
      }
      card += arrCh[cardTemp % 11];
      return card;
    }
    return card;
  },
  //微信授权
  wxConfig(params) {
    let wLoca = window.location;
    if (!device.isWeixin) return;
    common.ajax({
      url: conf.api.wechatconfig,
      type: "get",
      data: {
        url: wLoca.origin + wLoca.pathname + wLoca.search,
      },
      success: (res) => {
        let setting = common.merge(
          {},
          {
            debug: false,
            jsApiList: [
              "checkJsApi",
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "onMenuShareQQ",
              "onMenuShareWeibo",
              "onMenuShareQZone",
              "chooseImage",
              "previewImage",
              "uploadImage",
              "downloadImage",
              "scanQRCode",
              "getLocation",
            ],
          },
          {
            appId: res.data.appId,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            timestamp: res.data.timestamp,
          },
          params
        );
        if (typeof wx !== "undefined") {
          wx.config(setting);
        }
      },
    });
  },
  wxShare(options) {
    var link = window.location.href;
    if (!device.isWeixin) return;
    wx.ready(function() {
      let setting = common.merge(
        {},
        {
          title: "就诊人管理", // 分享标题
          link: link, // 分享链接
          imgUrl:
            "https://paiyang.oss-cn-hangzhou.aliyuncs.com/cunyi/examin_list_s_4.png", // 分享图标
          desc: "手机预约问诊时间，更方便，更省时",
          success: function() {},
          cancel: function() {},
        },
        options
      );

      if (!/^http/.test(setting.imgUrl)) {
        setting.imgUrl = "http:" + setting.imgUrl;
      }
      let setting_1 = {
        title: setting.title,
        link: setting.link,
        imgUrl: setting.imgUrl,
        desc: setting.desc,
        success: setting.success,
        cancel: setting.cancel,
      };
      let setting_2 = {
        title: setting.title,
        link: setting.link, // 分享链接
        imgUrl: setting.imgUrl, // 分享图标
        success: setting.success,
        cancel: setting.cancel,
      };
      let setting_3 = {
        title: setting.title,
        link: setting.shortlink, // 分享链接
        imgUrl: setting.imgUrl, // 分享图标
        desc: setting.desc,
        success: setting.success,
        cancel: setting.cancel,
      };
      wx.checkJsApi({
        jsApiList: [
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "onMenuShareQZone",
        ],
        success: function(res) {
          wx.onMenuShareTimeline(setting_2);
          wx.onMenuShareAppMessage(setting_1);
          wx.onMenuShareQQ(setting_3);
          wx.onMenuShareWeibo(setting_3);
          wx.onMenuShareQZone(setting_3);
        },
      });
    });
  },
  isWeChatMiniApp() {
    const ua = window.navigator.userAgent.toLowerCase();
    return new Promise((resolve) => {
      if (ua.indexOf("micromessenger") == -1) {
        console.log("不在微信或者小程序中");
        resolve(false);
      } else {
        if (typeof wx !== "undefined") {
          if (wx && wx.miniProgram && wx.miniProgram.getEnv) {
            wx.miniProgram.getEnv((res) => {
              if (res.miniprogram) {
                console.log("在小程序中");
                resolve(true);
              } else {
                //在微信中
                console.log("在微信中");
                resolve(false);
              }
            });
          } else {
            const isMininWx = /miniProgram/i.test(ua);
            resolve(isMininWx);
          }
        } else {
          SJ(["https://res.wx.qq.com/open/js/jweixin-1.6.0.js"], function(wx) {
            if (wx && wx.miniProgram && wx.miniProgram.getEnv) {
              wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                  console.log("在小程序中");
                  resolve(true);
                } else {
                  //在微信中
                  console.log("在微信中");
                  resolve(false);
                }
              });
            } else {
              const isMininWx = /miniProgram/i.test(ua);
              resolve(isMininWx);
            }
          });
        }
      }
    });
  },
  // ajax
  ajax(options) {
    const data = options.data || {};
    const header = options.header || {};
    const timeout = options.timeout || 0;

    console.log("接口测试环境", PROCESS.ENV);
    if (PROCESS.ENV === "test") {
      const pathnameList = location.pathname.split("/");
      const envName = pathnameList[1] || "";
      console.log("test请求的url", options.url, envName);
      options.url = options.url.replace(
        "/192.168.0.73:8081/",
        `/${envName}/192.168.0.73:8081/`
      );
    }
    console.log("接口请求方式", options.type);
    if (options.type === "post") {
      axios
        .post(options.url, data, { headers: header, timeout: timeout })
        .then((response) => {
          console.log("post成功", response, options);
          common.ajaxResult(response, options);
        })
        .catch((error) => {
          console.log("post失败", error, options);
          common.ajaxError(error, options);
        });
    }
    if (options.type === "get") {
      axios
        .get(options.url, { params: data, headers: header, timeout: timeout })
        .then((response) => {
          console.log("get成功", response, options);
          common.ajaxResult(response, options);
        })
        .catch((error) => {
          console.log("get失败", error, options);
          common.ajaxError(error, options);
        });
    }
  },
  ajaxError(err, options) {
    // token验证失效
    if (err.status == "401") {
      return;
    }
    if (options.error) {
      options.error(err);
    } else {
      const msg =
        err.errorMsg ||
        (err.data && err.data.errorMsg) ||
        "程序员小哥正在处理，请稍后再试试";
      common.MsgBox.hint(msg);
    }
  },
  ajaxResult(response, options) {
    if (!response.data) return;
    const status = response.data.code;
    options.complete && options.complete(response.data);

    if (status == "401") {
      return;
    } else if (status == "200") {
      options.success && options.success(response.data);
    } else {
      if (!options.noalert) {
        if (response.data.errorMsg) {
          common.MsgBox.hint(response.data.errorMsg, "", "", 1500, () => {
            options.error && options.error(response);
          });
        }
      } else {
        options.error && options.error(response);
      }
    }
  },
  // 静默授权绑定手机
  verifyphonesns(GotoBack, CallBack) {
    const openid = common.wsCache.get("openid");
    if (!openid) {
      let appid = "wx77b712651baaa5a7";
      // let appid = "wxb69a63bde2c7d8a3";
      let redirect_Url = encodeURIComponent(window.location.href); //重定向回来的地址
      console.log("重定向回来的地址", redirect_Url);
      let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_Url}&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect`;
      common.getwxopenidsns(url);
    } else {
      const info = common.wsCache.get("token");
      // 没有用户信息 重刷页面
      if (!info) {
        common.wsCache.clear();
        window.location.reload();
      }
    }
  },
  // 获取openid（有code 直接获取，无code 跳转微信授权页获取code）
  getwxopenidsns(url) {
    let urls = url;
    const code = common.getUrlParam("code");
    console.log("获取的URL", url, "获取的code", code);
    let openid = "";
    let token = "";
    if (code) {
      console.log("有code ----------");
      // 获取参数
      let listtext = "";
      if (window.location.search.indexOf("&code") != -1) {
        listtext = window.location.search.split("&code")[0];
      }
      if (window.location.search.indexOf("?code") != -1) {
        listtext = window.location.search.split("?code")[0];
      }
      urls = `${window.location.protocol}//${window.location.host}${
        window.location.pathname
      }${listtext}`;
      console.log("66666666", urls);
      common.ajax({
        type: "get",
        url: conf.api.getWxUserInfoByCode,
        data: { code: code },
        complete: (res) => {
          console.log("获取openid", res);
          if (res.code == 200) {
            openid = res.data.openId;
            token = res.data.token;
            common.wsCache.set("openid", openid, { exp: conf.sexp });
            common.wsCache.set("token", token, { exp: conf.sexp });
            // common.wsCache.set("UserInfo", res.result, { exp: conf.sexp });
            window.location.href = urls;
          } else {
            // 无效code 重新进入页面
            window.location.href = urls;
          }
        },
      });
    } else {
      console.log("无code ----------");
      let appid = "wx77b712651baaa5a7";
      // let appid = "wxb69a63bde2c7d8a3";
      let redirect_Url = encodeURIComponent(window.location.href); //重定向回来的地址
      //获取code的地址。获取成功重定向后地址栏中将会带有code，判断没有code的话，就跳转到微信官方链接上获取，获取成功后会再重定向回来，注意url是需要使用encodeURIComponent处理一下编码的
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_Url}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
    }
  },
  // 授权登录
  verifylogin(GotoBack, CallBack) {
    const info = common.wsCache.get("token");
    // 没有用户信息 重刷页面
    if (!info) {
      GotoBack && GotoBack();
    } else {
      CallBack && CallBack();
    }
  },
  // url上取值
  getUrlParam(name) {
    if (name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURIComponent(r[2]);
      return null;
    } else {
      var url = location.search;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        if (str.indexOf("&") != -1) {
          let strs = str.split("&");
          for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURIComponent(
              strs[i].split("=")[1]
            );
          }
        } else {
          theRequest[str.split("=")[0]] = decodeURIComponent(str.split("=")[1]);
        }
      }
      return theRequest;
    }
  },
  // 合并对象
  merge(target) {
    // arguments 类数组对象
    for (let i = 1, j = arguments.length; i < j; i++) {
      let source = arguments[i] || {};
      for (let prop in source) {
        if (source.hasOwnProperty(prop)) {
          let value = source[prop];
          if (value !== undefined) {
            target[prop] = value;
          }
        }
      }
    }
    return target;
  },
  joinUrlPath(url) {
    console.log(
      "环境",
      process.env.NODE_ENV,
      process.env.BASE_URL,
      PROCESS.ENV,
      url
    );
    if (PROCESS.ENV === "test") {
      const pathnameList = location.pathname.split("/");
      envName = pathnameList[1] || "";
      if (
        url.includes("https://") ||
        url.includes("http://") ||
        url.indexOf("//") === 0
      ) {
        return url;
      } else {
        return `/${envName}${url}`;
      }
    } else {
      return url;
    }
  },
};

export default common;
